// UserProfile.tsx
import React, { useState, useEffect } from "react";
import {
  ProfileContainer,
  SectionTitle,
  UserDataContainer,
  DataRow,
  DataLabel,
  DataValue,
  Form,
  FormGroup,
  Label,
  Input,
  SubmitButton,
} from "./UserProfile.styles";
import notify from "devextreme/ui/notify";
import { apiService } from "../../services/apiService";
import { useNavigate } from "react-router-dom";
import { Button } from "devextreme-react/button";

interface User {
  id: string;
  name: string;
  email: string;
  username: string;
  nomina: string;
}

const UserProfile = () => {
  const [user, setUser] = useState<User | null>(null);
  const navigate = useNavigate();
  const [passwordFields, setPasswordFields] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  useEffect(() => {
    try {
      const storedUserDataString = localStorage.getItem("userData");

      if (storedUserDataString) {
        const storedData = JSON.parse(storedUserDataString);

        if (storedData && storedData.user) {
          // --- ESTA ES LA PARTE CORREGIDA ---
          const sourceUser = storedData.user;

          // 1. Creamos un nuevo objeto que coincida con la interfaz 'User'
          const formattedUser: User = {
            id: sourceUser.id,
            name: sourceUser.nombre, // Mapeo: nombre -> name
            email: sourceUser.correo, // Mapeo: correo -> email
            username: sourceUser.nomina, // Usamos 'nomina' como 'username'
            nomina: sourceUser.nomina,
          };

          // 2. Guardamos el objeto ya formateado en el estado
          setUser(formattedUser);
        } else {
          console.warn(
            "La estructura de 'userData' en localStorage no contiene la propiedad 'user'.",
          );
        }
      } else {
        console.warn("No se encontraron datos del usuario en localStorage.");
      }
    } catch (error) {
      console.error("Error al leer o procesar datos de localStorage:", error);
    }
  }, []);

  // El resto del componente permanece exactamente igual...

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPasswordFields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const { newPassword, confirmPassword } = passwordFields;

    if (newPassword !== confirmPassword) {
      alert("La nueva contraseña y la confirmación no coinciden.");
      return;
    }
    if (newPassword.length < 8) {
      notify("La contraseña debe tener al menos 8 caracteres.", "info", 3000);
      return;
    }
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&._-])/;
    if (!pattern.test(newPassword)) {
      notify(
        "La contraseña debe incluir mayúsculas, minúsculas, números y caracteres especiales.",
        "info",
        4000,
      );
      return;
    }

    try {
      if (!user || !user.nomina) {
        notify(
          "No se pudo obtener el identificador del usuario.",
          "error",
          3000,
        );
        return;
      }
      const resetNomina = user.nomina;
      await apiService.patch(
        `/api/Usuarios/updatepsw/${resetNomina}`,
        newPassword,
      );
      notify("Tu contraseña ha sido restablecida con éxito.", "success", 3000);
      setPasswordFields({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (error) {
      console.error("Error al actualizar la contraseña:", error);
      notify("Error al restablecer la contraseña.", "error", 3000);
    }
  };

  if (!user) {
    return (
      <ProfileContainer>
        Cargando perfil o no se encontraron datos de sesión...
      </ProfileContainer>
    );
  }

  return (
    <ProfileContainer>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "15px",
        }}
      >
        <Button
          icon="chevronleft"
          text="Regresar"
          stylingMode="outlined"
          type="default"
          onClick={() => navigate(-1)}
        />
      </div>
      <SectionTitle>Datos del Usuario</SectionTitle>
      <UserDataContainer>
        <DataRow>
          <DataLabel>Nombre:</DataLabel>
          <DataValue>{user.name}</DataValue>
        </DataRow>
        <DataRow>
          <DataLabel>Email:</DataLabel>
          <DataValue>{user.email}</DataValue>
        </DataRow>
        <DataRow>
          <DataLabel>Nomina:</DataLabel>
          <DataValue>{user.username}</DataValue>
        </DataRow>
      </UserDataContainer>

      <SectionTitle>Cambiar Contraseña</SectionTitle>
      <Form onSubmit={handleSubmit}>
        {/* ... El resto del formulario no necesita cambios ... */}
        <FormGroup>
          <Label htmlFor="currentPassword">Contraseña Actual</Label>
          <Input
            type="password"
            id="currentPassword"
            name="currentPassword"
            value={passwordFields.currentPassword}
            onChange={handlePasswordChange}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="newPassword">Nueva Contraseña</Label>
          <Input
            type="password"
            id="newPassword"
            name="newPassword"
            value={passwordFields.newPassword}
            onChange={handlePasswordChange}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="confirmPassword">Confirmar Nueva Contraseña</Label>
          <Input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            value={passwordFields.confirmPassword}
            onChange={handlePasswordChange}
            required
          />
        </FormGroup>
        <SubmitButton type="submit">Actualizar Contraseña</SubmitButton>
      </Form>
    </ProfileContainer>
  );
};

export default UserProfile;
